
(function(){
  const modal=document.getElementById('modal');
  const closeModal=document.getElementById('closeModal');
  function dismiss(){ if(modal){modal.classList.remove('show')} document.body.classList.remove('locked'); }
  if(closeModal) closeModal.addEventListener('click',dismiss);
  if(modal) modal.addEventListener('click',e=>{if(e.target===modal)dismiss();});
  const nav=document.getElementById('nav');
  window.addEventListener('scroll',()=>{if(nav) nav.classList.toggle('scrolled',window.scrollY>40);});
  const io=new IntersectionObserver((entries)=>{entries.forEach(en=>{if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}});},{threshold:.15});
  document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
})();
